import { environment } from '@env';
import { Component, OnInit } from '@angular/core';
import { ZSuiteHelper } from '@shared/helpers/zsuite-helper';
import { BrowserService } from '@shared/services/browser.service';
import { ZSuiteService } from '@shared/services/zsuite.service';
import { Observable, Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { UserService } from '@shared/modules/account/services/user.service';
import { GlobalLoaderService } from '@shared/services/global-loader.service';
import { NbThemeService } from '@nebular/theme';
import { ThemeHelper } from '@shared/helpers/theme.helper';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  mobileMenu = true;
  subscription = new Subscription();
  isZSuite = false;

  constructor(
    private userService: UserService,
    private browserService: BrowserService,
    private zSuiteService: ZSuiteService,
    private translate: TranslateService,
    private loaderService: GlobalLoaderService,
  ) {
    this.translate.setDefaultLang('en');

    this.browserService.screenSizeChanged(900).subscribe((res: boolean) => {
      this.mobileMenu = res;
    });
  }

  isLogged(): Observable<boolean> {
    return this.userService.isLoggedIn();
  }

  isLoading(): Observable<boolean> {
    return this.loaderService.subscription;
  }
 
  ngOnInit() {
    this.isZSuite = ZSuiteHelper.isZSuite();

    if (window.location.protocol === "http:" && environment.production) {
      window.location.href = window.location.href.replace("http:", "https:");
    }

    if (this.isZSuite) {
      this.zSuiteService.registerCloudInZSuite();
    }
  }
}
